import React from 'react';
import PropTypes from 'prop-types';

import Row from '../../../../../../../components/Row';
import Column from '../../../../../../../components/Column';
import Label from '../../../../../../../components/Label';
import Input from '../../../../../../../components/Input';

const ColorInputs = (props) => {
  const { id, value, onChange, textLabel, errors } = props;

  return (
    <div>
      <Label name={id} title={textLabel} errors={errors} />
      <Row>
        <Column>
          <Input
            id={id}
            placeholder="format #......"
            value={value}
            onChange={onChange}
          />
        </Column>
        <Column>
          <Input type="color" id={id} value={value} onChange={onChange} />
        </Column>
      </Row>
    </div>
  );
};
export default ColorInputs;

ColorInputs.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  textLabel: PropTypes.string.isRequired,
  errors: PropTypes.shape(),
  onChange: PropTypes.func.isRequired,
};

ColorInputs.defaultProps = {
  errors: {},
};
